import { makeStyles } from '@material-ui/core';

export const Confirmation2FADialogStyles = makeStyles({
    dialogStyle: {
      padding: '30px 26px',
      minWidth: '275px',
      borderRadius: '0.5rem',
    },
    dialogTitle: {
      padding: 0,
      fontSize: '26px',
      fontFamily: 'RobotoMedium',
      fontWeight: 400,
      lineHeight: 'normal',
      color: '#4b1c46',
      marginBottom: '16px',
    },
    contentStyle: {
      fontSize: '18px',
      color: '#545964',
      lineHeight: 'normal',
      fontWeight: 'normal',
      margin: 0,
    },
    sharedButtonStyle: {
      width: '100px',
      height: '40px',
      borderRadius: '4px',
      fontSize: '16px',
      fontWeight: 500,
      margin: 0,
      padding: 0,
      lineHeight: 'normal',
      textTransform: 'capitalize',
    },
    confirmButtonStyle: {
      color: '#fff',
      boxShadow: 'none',
      fontWeight: 400,
      background: 'linear-gradient(to left, #421a40 100%, #29132e 0%)',
      '&:disabled': {
        background: 'linear-gradient(to left, #776a7b 99%, #876e86 0%)',
        color: '#fff'
      }
    },
    cancelButtonStyle: {
      color: '#29132e',
      border: 'solid 1px #29132e'
    },
    dialogContentStyle: {
      padding: 0,
      marginBottom: '26px'
    },
    dialogActionStyle: {
      padding: 0,
      margin: '15px 0 0 0'
    },
    actionsSpacing: {
      '& :not(:first-child)': {
        marginLeft: '25px'
      }
    },
    input: {
      width: '150px',
      marginTop: '16px'
    },
    errorTextStyle: {
      color: 'red',
      fontSize: '14px',
      marginTop: '10px'
    }
  });
